

import React from 'react';
import AudienceBuilder from '../../components/automation/AudienceBuilder'; // adjust if path is different
//import { PageHeader } from '../../components/common'; // adjust if you have a common header component
import { Container } from '@mui/material';

const CreateAudiencePage = () => {
  return (
    <Container maxWidth="md">
      <AudienceBuilder />
    </Container>
  );
};

export default CreateAudiencePage;